module.exports = __webpack_public_path__ + "img/21.5eec4c59.jpg";